import { Radar, ShieldX } from 'lucide-react'

export default function Blocked() {
  const handleLogout = async () => {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' })
    window.location.href = '/login'
  }

  return (
    <div className="min-h-screen bg-light-body flex items-center justify-center">
      <div className="bg-white border border-[#E2E4ED] rounded-2xl p-10 w-full max-w-sm text-center">
        <div className="mb-6">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-to-br from-orion-primary to-orion-purple mb-4">
            <Radar className="w-7 h-7 text-[#1B2559]" strokeWidth={1.25} />
          </div>
          <h1 className="text-2xl font-bold text-[#1B2559] tracking-tight">Orion</h1>
        </div>
        <div className="flex items-center justify-center w-12 h-12 bg-red-50 rounded-full mx-auto mb-4">
          <ShieldX className="w-6 h-6 text-red-500" />
        </div>
        <h2 className="text-lg font-semibold text-[#1B2559] mb-2">Accès refusé</h2>
        <p className="text-sm text-[#8B8FA7] mb-6">
          Votre accès à Orion a été désactivé. Contactez l'administrateur si vous pensez qu'il s'agit d'une erreur.
        </p>
        <button
          onClick={handleLogout}
          className="text-sm text-[#555A73] hover:text-[#1B2559] underline transition-colors"
        >
          Se déconnecter
        </button>
      </div>
    </div>
  )
}
